import { LargeContentContainer } from '@mews-commander/ui';
import { Stack, Title } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { DigitalKeyConfigurationContent } from './DigitalKeyConfigurationContent';

export const DigitalKeyConfiguration = () => (
    <>
        <LargeContentContainer>
            <Stack spacing="300" vertical>
                <Title level={2}>
                    <LocalizedText textKey={TextKey.DigitalKey} />
                </Title>
                <DigitalKeyConfigurationContent />
            </Stack>
        </LargeContentContainer>
    </>
);
